export default __webpack_public_path__ + "static/media/predatoryinstincts.e440f538.png";